export const SET_ACTIVE_CUSTOMER_ACCOUNT = 'SET_ACTIVE_CUSTOMER_ACCOUNT';

export const FETCH_CUSTOMER_ACCOUNTS_REQUEST =
  'FETCH_CUSTOMER_ACCOUNTS_REQUEST';
export const FETCH_CUSTOMER_ACCOUNTS_SUCCESS =
  'FETCH_CUSTOMER_ACCOUNTS_SUCCESS';
export const FETCH_CUSTOMER_ACCOUNTS_FAILURE =
  'FETCH_CUSTOMER_ACCOUNTS_FAILURE';

export const UPDATE_CUSTOMER_ACCOUNT_REQUEST =
  'UPDATE_CUSTOMER_ACCOUNT_REQUEST';
export const UPDATE_CUSTOMER_ACCOUNT_SUCCESS =
  'UPDATE_CUSTOMER_ACCOUNT_SUCCESS';
export const UPDATE_CUSTOMER_ACCOUNT_FAILURE =
  'UPDATE_CUSTOMER_ACCOUNT_FAILURE';
